import { render } from "./BorderInputPrefix.vue?vue&type=template&id=11a71bfb&scoped=true"
import script from "./BorderInputPrefix.vue?vue&type=script&lang=js"
export * from "./BorderInputPrefix.vue?vue&type=script&lang=js"

import "./BorderInputPrefix.vue?vue&type=style&index=0&id=11a71bfb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11a71bfb"

export default script